// Libreria condivisa EVENTI (helper + registro categorie DINAMICO).
// Le categorie arrivano dal backend; qui teniamo un registro aggiornabile
// così i componenti possono risolvere colore/etichetta per slug senza prop-drilling.

const DEFAULT_CATEGORIES = [
  { slug: 'olistico', label: 'Olistico', hsl_var: '--evt-olistico', order: 1 },
  { slug: 'sportivo', label: 'Sportivo', hsl_var: '--evt-sportivo', order: 2 },
  { slug: 'benessere', label: 'Benessere', hsl_var: '--evt-benessere', order: 3 },
  { slug: 'culturale', label: 'Culturale', hsl_var: '--evt-culturale', order: 4 },
  { slug: 'naturalistico', label: 'Naturalistico', hsl_var: '--evt-naturalistico', order: 5 },
  { slug: 'ludico', label: 'Ludico', hsl_var: '--evt-ludico', order: 6 },
  { slug: 'avventura', label: 'Avventura', hsl_var: '--evt-avventura', order: 7 },
  { slug: 'enogastronomico', label: 'Enogastronomico', hsl_var: '--evt-enogastronomico', order: 8 },
  { slug: 'altro', label: 'Altro', hsl_var: '--evt-altro', order: 9 },
];

let _registry = {};
function _seed(list) {
  const reg = {};
  (list || []).forEach((c) => { reg[c.slug] = { label: c.label, hslVar: c.hsl_var || c.hslVar || '--brand-pine', order: c.order }; });
  return reg;
}
_registry = _seed(DEFAULT_CATEGORIES);

// Aggiorna il registro con le categorie dal backend.
export function setCategories(list) {
  if (Array.isArray(list) && list.length) _registry = _seed(list);
}

export const categoryMeta = (slug) => _registry[slug] || { label: slug || 'Evento', hslVar: '--muted-foreground' };

export const catColor = (slug, alpha) => {
  const v = categoryMeta(slug).hslVar || '--muted-foreground';
  return alpha != null ? `hsl(var(${v}) / ${alpha})` : `hsl(var(${v}))`;
};

// Immagine hero/copertina di fallback (quando un evento non ha cover propria).
export const EVENTS_HERO_IMG =
  'https://images.unsplash.com/photo-1701280737263-ea4f9bf3ad67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxmb3Jlc3QlMjBsYWtlJTIwc3VucmlzZXxlbnwwfHx8Ymx1ZXwxNzg2ODc4NTA4fDA&ixlib=rb-4.1.0&q=85';

// ---- Helper date/valuta ----
export const dayKey = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
};

export const euro = (n) => `€${Number(n || 0).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const fmtLongDate = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
};

export const fmtShortDate = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('it-IT', { day: '2-digit', month: 'short' });
};
